module.exports = __webpack_public_path__ + "static/media/store-facebook.5fc67cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store-facebook.png
// module id = 102
// module chunks = 0